import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => { };

@Component({
    selector: 'paetep-search',
    templateUrl: './paetep-search.component.html',
    styleUrls: ['./paetep-search.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PaetepSearchComponent)
        }
    ]
})
export class PaetepSearchComponent implements ControlValueAccessor {
    @Input() isBusy: boolean = false;
    @Input() isReadOnly: boolean = false;
    @Input() inputId: string = 'paetepSearchInput';

    @Output() onBlur = new EventEmitter<any>();
    @Output() onSearch = new EventEmitter<any>();
    @Output() onReset = new EventEmitter<any>();

    public searchText?: string = '';
    private _isFormDisabled: boolean = false;

    constructor() { }

    get isDisabled() {
        return this._isFormDisabled || this.isReadOnly;
    }

    onChange = (value: string) => {
        this.searchText = value;
        this.onChangeCallback(value);
    }

    onBlurEvent = () => {
        this.onBlur.emit();
    }

    onResetButtonClicked = () => {
        this.onReset.emit();
    }

    onSearchButtonClicked = () => {
        this.onSearch.emit();
    }

    writeValue(obj: any): void {
        this.searchText = obj;
    }

    registerOnChange = (fn: any): void => {
        this.onChangeCallback = fn;
    }

    registerOnTouched = (fn: any): void => {
        this.onTouchedCallback = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this._isFormDisabled = isDisabled;
    }

    public onTouchedCallback: () => void = noop;
    public onChangeCallback: (_: any) => void = noop;
}
